"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = selectPixel;
var _enums = require("../enums");
var _selectPixelFromBrc = _interopRequireDefault(require("./select-pixel-from-brc"));
var _selectPixelFromBRC = _interopRequireDefault(require("./select-pixel-from-b-r-c"));
var _selectPixelFromBRc = _interopRequireDefault(require("./select-pixel-from-b-rc"));
var _selectPixelFromRcb = _interopRequireDefault(require("./select-pixel-from-rcb"));
var _selectPixelFromRcB = _interopRequireDefault(require("./select-pixel-from-rc-b"));
var _selectPixelFromRCB = _interopRequireDefault(require("./select-pixel-from-r-c-b"));
var _selectPixelFromRCb = _interopRequireDefault(require("./select-pixel-from-r-cb"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function selectPixel(data, {
  depth,
  height,
  layout,
  width
}) {
  // console.log("layout:", {layout, data, depth, width});
  switch (layout) {
    case _enums.Layout["[band][row][column]"]:
      // @ts-ignore
      return _selectPixelFromBRC.default.bind(null, data, depth);
    case _enums.Layout["[band][row,column]"]:
      // @ts-ignore
      return _selectPixelFromBRc.default.bind(null, data, depth, width);
    case _enums.Layout["[band,row,column]"]:
      // @ts-ignore
      return _selectPixelFromBrc.default.bind(null, data, depth, height, width);
    case _enums.Layout["[row,column][band]"]:
      // @ts-ignore
      return _selectPixelFromRcB.default.bind(null, data, width);
    case _enums.Layout["[row][column][band]"]:
      // @ts-ignore
      return _selectPixelFromRCB.default.bind(null, data);
    case _enums.Layout["[row][column,band]"]:
      // @ts-ignore
      return _selectPixelFromRCb.default.bind(null, data, depth);
    case _enums.Layout["[row,column,band]"]:
      // @ts-ignore
      return _selectPixelFromRcb.default.bind(null, data, depth, width);
    default:
      throw new Error("[pixel-utils] unknown layout " + layout);
  }
}